import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Hero from '../components/Hero';
import CategorySection from '../components/CategorySection';

const Home: React.FC = () => {
  const navigate = useNavigate();

  const handleSearch = (searchTerm: string) => {
    navigate(`/browse?search=${encodeURIComponent(searchTerm)}`);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Hero onSearch={handleSearch} />
      <main className="flex-grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <CategorySection />
          
          {/* CTA Section */}
          <section className="mt-16 py-12 bg-hackGreen-100 rounded-lg text-center">
            <div className="container mx-auto px-4">
              <h2 className="text-3xl font-bold mb-4">Join Our Community Today</h2>
              <p className="text-xl mb-8 max-w-2xl mx-auto">Be part of a growing network of innovators sharing accessibility solutions.</p>
              <Link
                to="/submit"
                className="button-primary"
              >
                Submit Your Hack
              </Link>
            </div>
          </section>
        </div>
      </main>
      {/* Footer is already included in the App layout */}
    </div>
  );
};

export default Home;
